import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { HaloAnimation } from "../components/HaloAnimation";
import { PickScamResult } from "../types";
import { IMAGE_DATABASE } from "../variables";

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  z-index: 10;
  text-align: center;
  padding: 2rem 1rem;
  box-sizing: border-box;
`;

const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: #e8eefc;
  letter-spacing: 0.02em;
  margin-bottom: 12px;

  background: linear-gradient(
    90deg,
    #757ea7 -8.1%,
    #ffffff 53.63%,
    #3e466d 108.63%
  );
  -webkit-text-fill-color: transparent;
  background-clip: text;

  /* 針對平板尺寸 */
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 42px;
    line-height: 62px;
    margin-bottom: 60px;
  }
`;

const HaloContainer = styled.div`
  width: 70%;
`;

const Sub = styled.div`
  margin-top: -12px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);

  /* 針對平板尺寸 */
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 20px;
    margin-top: 60px;
  }
`;

export default function VerifyingPage() {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: PickScamResult };
  const [loadingDots, setLoadingDots] = useState(1);

  // 動畫效果：循環變化 "." -> ".." -> "..." 每 300ms
  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingDots((prev) => (prev % 3) + 1);
    }, 400);

    return () => clearInterval(interval);
  }, []);

  // 計算結果：questions 當中所有的詐騙圖片剛好等於 answers 的話則結果正確
  const isCorrect = useMemo(() => {
    if (!state) return false;

    const { questions, answers } = state;

    // 從 questions 中找出所有的詐騙圖片 ID
    const scamImagesInQuestions = questions.filter((questionId) => {
      const imageData = IMAGE_DATABASE.find((img) => img.id === questionId);
      return imageData?.isScam === true;
    });

    // 比較：answers 是否剛好等於所有詐騙圖片
    if (scamImagesInQuestions.length !== answers.length) {
      return false;
    }

    // 檢查每個詐騙圖片是否都在 answers 中
    return scamImagesInQuestions.every((scamId) => answers.includes(scamId));
  }, [state]);

  useEffect(() => {
    console.log("VerifyingPage state:", state);
    console.log("Result is correct:", isCorrect);

    // 3 秒後自動跳轉到結果頁面
    const timer = setTimeout(() => {
      navigate("/scam-result", { state: { ...state, isCorrect } });
    }, 3000);

    return () => clearTimeout(timer);
  }, [state, isCorrect, navigate]);

  return (
    <Page>
      <Title>正在仔細分析，請稍後</Title>
      <HaloContainer>
        <HaloAnimation />
      </HaloContainer>
      <Sub>資料確認中{".".repeat(loadingDots)}</Sub>
    </Page>
  );
}
